import React from "react";
import { FieldState } from "js/types";
import AppTextField, {
    AppTextFieldProps
} from "js/react/components/AppTextField";

export type TextFieldWithErrorProps = AppTextFieldProps & {
    errorInfo?: FieldState;
};

export const TextFieldWithError = ({
    errorInfo,
    ...rest
}: TextFieldWithErrorProps) => {
    return (
        <AppTextField
            helperText={
                errorInfo && errorInfo.errors.length > 0
                    ? errorInfo.errors[0].message
                    : ""
            }
            error={errorInfo && errorInfo.errors.length > 0}
            {...rest}
        />
    );
};

export default TextFieldWithError;
